export default "__VITE_ASSET__Cl4nr50z__"